import AbstractStonecodeFileFileStatusModel from './AbstractStonecodeFileFileStatusModel';
import doc                                  from '@widesk-core/decorators/doc';
import model                                from '@widesk-core/decorators/model';

@doc.urnResource('stonecode_file_file_status')
@model.cacheDuration()
export default class StonecodeFileFileStatusModel extends AbstractStonecodeFileFileStatusModel {
}
